@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';
@import (reference) './tree-item.module.less';
@import (reference) './tree-item-content/tree-item-content.module.less';

/** <TreeNavigation> **/
.tree-navigation {
  height: 100%;
  background: var(--tree-nav--background-color);
  padding-top: @space-16;
  overflow: hidden;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  gap: @space-4;
}
/** </TreeNavigation> **/

/** <TreeItem> **/
@TreeItem();
/** </TreeItem> **/

/** <TreeItemContent> **/
.tree-navigation-item-row {
  @TreeNavItem_Default();
  @TreeNavItem_Expandable();
  @TreeNavItem_SubItem();
  @TreeNavItem_Selected();
  @TreeNavItem_SearchResult();
  @TreeNavItem_HasNoIcon();
}
/** </TreeItemContent> **/

/** <FlexRow> **/
@FlexRow_Default: {
  .tree-navigation-item-content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: @space-8 @space-16;
  }
};
@FlexRow_SubItem: {
  .tree-navigation-subitems .is-subitem .tree-navigation-item-content {
    // Design provided the unique spacing
    padding: 6px @space-12;
  }
};

@FlexRow_Default();
@FlexRow_SubItem();
/** </FlexRow> **/

/** <Link> **/
@Link: {
  .label {
    display: flex;
    gap: @space-8;
    align-items: center;
    overflow: hidden;

    background: inherit;
    color: var(--tree-nav--text-color);
    font-size: 14px;
    line-height: 20px;
    text-decoration: none;

    &:focus {
      background: inherit;
    }

    &:hover {
      text-decoration: none;
    }
  }
  .icon {
    color: var(--gray-637381);
    display: inline-flex;
    height: 12px;
    width: 12px;
  }
};
@Link();
/** </Link> **/

/** <ExpanderIcon /> **/
@ExpanderIcon: {
  // do not display by default
  .expander {
    display: none;
  }

  // only display if 'expandable' class is applied to parent
  .expandable .expander {
    flex: none;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 20px;
    width: 20px;

    > svg {
      fill: var(--tree-nav--expander-icon--fill-color);
      height: 12px;
      width: 12px;
    }
  }

  // rotate if 'expanded' class is applied to parent
  .expanded .expander {
    transform: rotate(90deg);
  }
};
@ExpanderIcon();
/** </ExpanderIcon> **/

/** <Label> **/
@Label: {
  .label-overflow {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 170px;

    &.has-badge {
      padding-right: @space-4;
    }
  }
};
@Label();
/** </Label> **/

/** <ItemIcon> **/
@ItemIcon: {
  .store-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    min-height: 20px;
    min-width: 20px;

    border-radius: 50%;

    > img {
      height: 15px;
      width: 15px;
    }
  }

  // add white circular cutout when selected
  .selected,
  .is-selected-and-highlighted {
    .store-icon-wrapper {
      background: var(--tree-nav--store-icon-cutout--background-color);
    }
  }
};
@ItemIcon();
/** </ItemIcon> **/

/** <TreeItemCount> **/
@TreeItemCount: {
  .count,
  .count-wrapper {
    flex: none;
  }

  .count-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
  }

  .count {
    display: flex;
    min-width: 20px;
    min-height: 20px;
    padding: @space-0 @space-8;
    justify-content: center;
    align-items: center;
    gap: 4px;

    color: var(--tree-nav--count-pill--text-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;

    border-radius: 16px;
    border: 1px solid var(--tree-nav--count-pill--selected--text-color);
    background: var(--tree-nav--count-pill--background-color);
  }
};
@TreeItemCount();
/** </TreeItemCount> **/
